import React from "react";

const TermsConditions = () => {
  return (
    <section className="feature-section">
      <div className="container">
        <div className="mb-5 pt-3 text-start">
          <h2 className="section-heading text-center mt-3">Terms and Conditions</h2>

          <p>
            Welcome to The Pilot Guide, an educational technology platform
            operated under RightSource, the primary company, with RightSource
            Aviation (RSA) as its subsidiary (collectively referred to as “we,”
            “our,” or “us”). The Pilot Guide is designed to support aspiring
            pilots in preparing for the Indian Commercial Pilot Licence (CPL),
            its required examinations, cadet pilot programmes, airline selection
            processes, and aircraft-specific airline preparation through
            structured, technology-enabled learning.
          </p>

          <p>
            By downloading, accessing, or using The Pilot Guide mobile
            application, website, or related services, you agree to be legally
            bound by these Terms of Service (“Terms”). If you do not agree, you
            must discontinue use immediately. The Pilot Guide provides
            exam-oriented educational services including practice questions,
            mock tests, exam-style simulations, chapter-wise assessments,
            analytics, progress tracking, and study resources covering subjects
            such as Air Navigation, Air Meteorology, Air Regulations, Radio
            Telephony (RTR-A), cadet pilot preparation, and airline and
            aircraft-specific preparation, strictly for learning and
            self-assessment purposes. Users must provide accurate registration
            details, maintain the confidentiality of their login credentials,
            and are responsible for all activities under their account; account
            sharing, misuse, multiple accounts per individual, or unauthorized
            access is prohibited. You agree to use The Pilot Guide only for
            lawful, personal, and non-commercial educational purposes and must
            not violate applicable laws, compromise academic integrity, infringe
            intellectual property rights, reproduce or distribute content
            without authorization, attempt unauthorized access, use automated
            tools, upload harmful material, or engage in misleading or
            disruptive conduct. All content on The Pilot Guide, including
            question banks, study material, software, branding, text, images,
            and visuals, is the intellectual property of RightSource or its
            licensors and is protected under applicable intellectual property
            laws; users are granted a limited, non-exclusive, non-transferable
            license for personal educational use only. By using The Pilot Guide,
            you grant us permission to use your name, photographs, testimonials,
            feedback, and non-sensitive content (where voluntarily provided) for
            marketing, promotional, educational, and branding purposes across
            digital and offline platforms, without additional compensation. You
            also expressly consent to receive communication from us, including
            service updates, promotional messages, emails, WhatsApp messages,
            and phone calls, related to our courses, offerings, events, and
            services; you may opt out of promotional communications at any time
            where legally required. Subscription plans, where applicable, are
            charged in advance, are non-refundable except as required by law, do
            not auto-renew, and may be revised with prior notice; payments are
            securely processed via third-party gateways, and failed payments may
            result in restricted or suspended access. The Pilot Guide is an
            educational support platform only and does not guarantee examination
            success, airline selection, aircraft type rating, or employment
            outcomes, and actual examinations or airline assessments may differ
            from practice content. Platform availability may be interrupted due
            to maintenance or technical updates. To the maximum extent permitted
            by law, RightSource, RightSource Aviation (RSA), and The Pilot Guide
            shall not be liable for indirect, incidental, or consequential
            damages arising from platform use. Personal data is collected and
            processed in accordance with our Privacy Policy. Users may terminate
            their account at any time, while we reserve the right to suspend or
            terminate access for violations, misuse, or prolonged inactivity.
            These Terms are governed by the laws of India, and all disputes,
            claims, or legal proceedings shall be subject exclusively to the
            jurisdiction of the courts in Mumbai, India, with any arbitration
            seated and conducted only in Mumbai, in accordance with the
            Arbitration and Conciliation Act, 2015, and conducted in English. We
            may update these Terms periodically, and continued use constitutes
            acceptance of the revised Terms.{" "}
            <b>For any queries, contact info@thepilotguide.in</b>. By using The
            Pilot Guide, you acknowledge that you have read, understood, and
            agreed to these Terms and the Privacy Policy, which together form
            the entire agreement.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;
